export enum UserRoleEnum {
    ENTERPRISE_ADMIN = 'EnterpriseAdmin',
    MODMED_ADMIN = 'ModMedAdmin',
    EYEFINITY_ADMIN = 'EyefinityAdmin',
    ORGANIZATION_USER = 'OrganizationUser',
    SEND_ENTERPRISE_INVITATION = 'SendEnterpriseInvitation'
}
